<template>
  <!-- 教师详情 -->
  <div class="certification_details">
    <el-main v-cloak>
      <div class="content">
        <div class="title pdlr20">
          <h2>
            <span class="back_btn" @click="back('personal_center_finaly_design_manage')">
              <i class="el-icon-arrow-left"></i>
            </span>毕设详情
          </h2>
        </div>
        <div class="detail_content" v-if="detail">
          <el-row class="detail_content_list">
            <h2>毕业展信息</h2>
            <el-col :span="24">
              <p class="normal_text">毕业展院校：{{detail.school_name}}</p>
            </el-col>
            <el-col :span="24">
              <p class="normal_text">毕业展年份：{{detail.exhibition_year}}</p>
            </el-col>
            <el-col :span="24">
              <p class="normal_text">毕业展名称：{{detail.exhibition_name}}</p>
            </el-col>
            <el-col :span="24">
              <p class="normal_text">展品分类：{{detail.exhibition_category_name}}</p>
            </el-col>
          </el-row>
          <el-row class="detail_content_list">  
            <h2>作品信息</h2>
            <el-col :span="24">
              <p class="normal_text">作品名称：{{detail.name}}</p>
            </el-col>
            <el-col :span="24">
              <p class="normal_text">作品说明：{{detail.synopsis}}</p>
            </el-col>
            <el-col :span="24">
              <p class="normal_text">
                <span style="vertical-align:top;">作品图片：</span>
                 <el-image
                    v-for="item in detail.image_detailsPath"
                    v-if="detail.image_detailsPath.length"
                    :src="item" 
                    :preview-src-list="detail.image_detailsPath">
                  </el-image>
              </p>
            </el-col>
            <el-col :span="24" style="margin:20px 0;">
              <p class="normal_text">
                <span style="vertical-align:top;">视频：</span>
                
                <img
                  v-if="detail.videoPath"
                  src="@/assets/img/common/vd.png"
                  style="cursor:pointer;"
                  @click="showVideo(detail.videoPath)"
                />
              </p>
            </el-col>
           <el-col :span="24">
              <p class="normal_text">
                <span style="vertical-align:top;">封面图：</span>
                
                <el-image 
                    :src="detail.coverPath" 
                    :preview-src-list="[detail.coverPath]">
                  </el-image>
              </p>
            </el-col>
            <el-col :span="24">
              <p class="normal_text">多人合作：
                <template v-for="item in detail.team_member_list">{{item.name}}</template>
              </p>
            </el-col>
          </el-row>
          <el-row>
             <h2>创作花絮</h2>
             <el-col :span="24">
              <p class="normal_text">花絮说明：{{detail.highlight_synopsis}}</p>
            </el-col>
            <el-col :span="24">
              <p class="normal_text">
                <span style="vertical-align:top;">花絮图片：</span>
                
                <el-image 
                    v-if="detail.highlight_image_detailsPath.length"
                    v-for="item in detail.highlight_image_detailsPath"
                    :src="item" 
                    :preview-src-list="detail.highlight_image_detailsPath">
                  </el-image>
              </p>
            </el-col>
           <el-col :span="24" style="margin:20px 0;">
              <p class="normal_text">
                 <span style="vertical-align:top;">花絮视屏：</span>
                 <img
                  v-if="detail.highlight_videoPath"
                  src="@/assets/img/common/vd.png"
                  style="cursor:pointer;"
                  @click="showVideo(detail.highlight_videoPath)"
                />
              </p>
            </el-col>
          </el-row>

         

          <div class="footer_btn">
            <template v-if="detail.status ==='IdentityCertifieStatusSubmitted'">
              <el-button type="primary" @click="deal('确认通过？','IdentityCertifieStatussuccess')">通 过</el-button>
              <el-button type="primary" @click="dialogVisible = true">退回修改</el-button>
            </template>
            <el-button type="primary" @click="showExamines">操作记录</el-button>
          </div>
        </div>
        <!-- 退回意见 -->
        <el-dialog title="退回修改" :visible.sync="dialogVisible" width="600px" destroy-on-close>
          <div>
            <el-input
              class="textarea-width"
              maxlength="30"
              show-word-limit
              rows="6"
              type="textarea"
              v-model="examine_remark"
              placeholder
            ></el-input>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="deal('确认退回修改？','IdentityCertifieStatusReturned')">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 处理记录 -->
        <el-dialog title="操作记录" :visible.sync="dialogVisible2" width="600px" destroy-on-close>
          <ul v-if="Examines.length">
            <li
              style="line-height:24px;"
              v-for="item in Examines"
            >{{item.create_date}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.content}}</li>
          </ul>
          <div class="center" v-else>暂无记录</div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 视频播放 -->
        <el-dialog title="视频播放" :visible.sync="dialogVisible3" destroy-on-close>
          <div>
            <video controls="controls" width="600" height="400" class="color_blue" :src="curVideo"></video>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </el-main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,//退回修改
      dialogVisible2: false,//操作记录
      dialogVisible3:false,//视频播放
      curVideo:'',//当前视频链接
      detail: null,
      Examines: [], //处理记录
      examine_remark: "" //退回修改意见参数
    };
  },
  computed: {
    designer() {
      return this.$store.state.designer;
    }
  },
  created() {
    if (this.designer) {
      this.teachergetOpus();
    } else {
      this.needInfo("designer", "teachergetOpus");
    }
  },
  methods: {
    showVideo(src){
      this.curVideo = src;
      this.dialogVisible3 = true;
    },
    /* 监测信息 */
    needInfo(name, fn) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    
    // 学生毕设列表
    teachergetOpus() {
      let params = {
        id: this.$route.query.id,
        teacher: this.designer.id
      };
      return new Promise(resolve => {
        this.api.teachergetOpus(params).then(res => {
          if (res.error.err_code !== 0) return;
          let detail = res.obj.list[0] || null;
          detail.image_detailsPath = detail.image_detailsPath.length?detail.image_detailsPath.split('|'):[];
          detail.highlight_image_detailsPath = detail.highlight_image_detailsPath.length?detail.highlight_image_detailsPath.split('|'):[];
          console.log(detail.highlight_image_detailsPath) 
          this.detail = detail;
          resolve();
        });
      });
    },
    // 操作提示
    deal(text, operation) {
      this.$confirm(`${text}`, "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(1111111);
          this.approvalByTeacherOpus(operation).then(res => {
            let _txt = "";
            if (operation === "IdentityCertifieStatussuccess") {
              _txt = "已通过!";
            } else if (operation === "IdentityCertifieStatusFailed") {
              _txt = "已不通过!";
            } else if (operation === "IdentityCertifieStatusReturned") {
              _txt = "已退回修改!";
              this.dialogVisible = false;
            }
            this.$message({
              type: "success",
              message: _txt
            });
            this.teachergetOpus
            ();
          });
        })
        .catch(() => {});
    },
    // 对学生认证操作
    approvalByTeacherOpus(operation) {
      return new Promise(resolve => {
        this.api
          .approvalByTeacherOpus({
            operation: operation,
            id: this.$route.query.id,
            examine_remark: this.examine_remark
          })
          .then(res => {
            if (res.error.err_code != 0) return;
            resolve(res);
          });
      });
    },
    // 显示操作记录
    showExamines() {
      this.getExamines().then(res => {
        this.dialogVisible2 = true;
      });
    },
    // 操作记录
    getExamines() {
      return new Promise(resolve => {
        this.api.getExamines({ code: this.$route.query.code }).then(res => {
          if (res.error.err_code != 0) return;
          this.Examines = res.obj.list || [];
          resolve(res);
        });
      });
    },
    back(tmp) {
      this.$router.push({
        name: tmp
      });
    }
  }
};
</script>

<style lang="scss">
.certification_details {
  background: #fff;
  padding: 20px 30px;
  .title {
    h2 {
      display: flex;
      align-items: center;
    }
  }
  .title::before {
    display: none;
  }
  .back_btn {
    display: inline-block;
    width: 38px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border: 1px solid #dcdfe6;
    margin-right: 14px;
    cursor: pointer;
    vertical-align: top;
  }
  .detail_content {
    padding: 0 20px;
    h2 {
      font-size: 16px;
      color: #4b5062;
      font-weight: bold;
      height: 31px;
      line-height: 31px;
    }
    .normal_text {
      font-size: 14px;
      color: #4b5062;
      line-height: 26px;
    }
    .detail_content_list {
      padding: 23px 0 22px;
      border-bottom: 1px solid rgba(231, 233, 236, 1);
    }
    img{
      max-width:100px;
      height: 100px;
      object-fit: cover;
      vertical-align: top;
    }
    img + img{
      margin-left:10px;
    }
    video{
      vertical-align: top;
      max-width:300px;
      max-height: 300px;
    }
    .el-image-viewer__img{
      max-width:300px;
      height: 300px;
    }
    .el-image {
      margin:0 10px 10px 0;
    }
  }
  .footer_btn {
    padding: 20px 0;
    
  }
  .el-icon-circle-close{
    color:#fff;
  }
}
</style>